var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNormalCallout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.914,
    height: 24.914,
    viewBox: "0 0 24.914 24.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings-phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.286,7.971H10.628v2.657h2.657V7.971Zm5.314,0H15.943v2.657H18.6V7.971Zm3.986,8.636a15.046,15.046,0,0,1-4.783-.8,1.636,1.636,0,0,0-1.329.266L13.551,19A20.683,20.683,0,0,1,4.783,10.23L7.706,7.307a1.058,1.058,0,0,0,.266-1.329,17.867,17.867,0,0,1-.664-4.65A1.255,1.255,0,0,0,5.979,0H1.329A1.255,1.255,0,0,0,0,1.329,22.567,22.567,0,0,0,22.586,23.914a1.255,1.255,0,0,0,1.329-1.329v-4.65a1.255,1.255,0,0,0-1.329-1.329ZM21.257,7.971v2.657h2.657V7.971Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalCallout);
export default __webpack_public_path__ + "static/media/normal-callout.da784815b2e34c59244a2c39e8091d45.svg";
export { ForwardRef as ReactComponent };